import React from "react"
import { CircularProgress } from "@material-ui/core"

const SpinnerIcon = (props) => <CircularProgress size={20} {...props} />

export default SpinnerIcon